module.exports = __webpack_public_path__ + "img/treatment-pack-1.635867a0.png";